<template>
  <b-modal
    centered
    :id="id"
    :title="$t('application-list-button-toolbar.modal.application-list-confirm-send-message.title')"
  >
    <p>{{ $t('application-list-button-toolbar.modal.application-list-confirm-send-message.content') }}</p>
    <template #modal-footer>
      <b-button variant="success" @click="confirm">
        {{ $t('application-list-button-toolbar.modal.application-list-confirm-send-message.button.yes.label') }}
      </b-button>
      <b-button variant="default" @click="cancel">
        {{ $t('application-list-button-toolbar.modal.application-list-confirm-send-message.button.no.label') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'application-list-confirm-send-message-modal',
  props: {
    id: { type: String, required: true }
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      this.$bvModal.hide(this.id);
    },
    cancel() {
      this.$emit('cancel');
      this.$bvModal.hide(this.id);
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  }
}
</script>
